(function () {
    'use strict';

    angular
        .module('adminGovernanceProcessControllers')
        .controller('EditGovernanceProcessController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'topBarService', 'adminGovernanceProcessService', 'fiscalYears', 'govProcessType', 'govProcess'];

    function Controller($rootScope, $scope, $state, topBarService, adminGovernanceProcessService, fiscalYears, govProcessType, govProcess) {

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Add Governance Process', 'fa fa-road');

        $scope.fiscalYears    = fiscalYears;
        $scope.govProcessType = govProcessType;
        $scope.govProcess     = govProcess;
        $scope.isSubmitting   = false;

        // Page is dirty
        $scope.pageIsDirty = function () {
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $rootScope.$broadcast('page-is-not-dirty');
        };

        if ($scope.govProcess.StartDate) $scope.govProcess.StartDate = moment($scope.govProcess.StartDate);
        if ($scope.govProcess.EndDate) $scope.govProcess.EndDate = moment($scope.govProcess.EndDate);
        if ($scope.govProcess.Deadline) $scope.govProcess.Deadline = moment($scope.govProcess.Deadline);

        // When in Create Mode
        if (_.isUndefined(govProcess.GovernanceProcessID)) {
            $scope.govProcess.FiscalYearID = fiscalYears[0].FiscalYearID;
            $scope.govProcess.ShortName = fiscalYears[0].Name;

            $scope.govProcess.GovernanceProcessTypeID = govProcessType.GovernanceProcessTypeID;

            $scope.pageIsDirty();
        }

        // Toggle Is Active
        $scope.toggleIsActive = function () {
            $scope.govProcess.IsActive = !$scope.govProcess.IsActive;
            $scope.pageIsDirty();
        };

        // Create Process
        $scope.createProcess = function () {
            if ($scope.isSubmitting) {
                return;
            }

            $scope.isSubmitting = true;

            adminGovernanceProcessService
                .createProcess($scope.govProcess)
                .then(function () {
                    $state.go('^', {}, { reload: true });
                })
                .finally(function () {
                    $scope.isSubmitting = false;
                });
        };

        // Update Process
        $scope.updateProcess = function () {
            if ($scope.isSubmitting) {
                return;
            }

            $scope.isSubmitting = true;

            adminGovernanceProcessService
                .updateProcess($scope.govProcess)
                .then(function () {
                    $state.go('^', {}, { reload: true });
                })
                .finally(function () {
                    $scope.isSubmitting = false;
                });
        };
    }
})();
